import { IAssetPurchaseOrder, IBusinessDevelopmentUser, IClientInstallation } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllAssetPurchaseOrder = async (clientInstallationId: string, projectInstallationId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order`
    );
    // const data = clientInstallations;
    return data as IAssetPurchaseOrder[];
};

export const getAssetPurchaseOrderById = async (
    clientInstallationId: string,
    projectInstallationId: string,
    purchaseOrderId: string
) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order/${purchaseOrderId}`
    );

    return data as IAssetPurchaseOrder;
};

export const addAssetPurchaseOrder = async (
    clientInstallationId: string,
    projectInstallationId: string,
    payload: any
) => {
    const { data, status } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order`,
        payload
    );
    return { data, status };
};

export const updateAssetPurchaseOrder = async (
    clientInstallationId: string,
    projectInstallationId: string,
    purchaseOrderId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order/${purchaseOrderId}`,
        payload
    );
    return data as IAssetPurchaseOrder;
};

export const updateFilePurchaseOrder = async (
    clientInstallationId: string,
    projectInstallationId: string,
    purchaseOrderId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order/${purchaseOrderId}/files`,
        payload
    );
    return data as IAssetPurchaseOrder;
};
export const removeFilePurchaseOrder = async (
    clientInstallationId: string,
    projectInstallationId: string,
    purchaseOrderId: string,
    fileId: string
) => {
    const { data } = await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order/${purchaseOrderId}/files/${fileId}`
    );
    return data as IAssetPurchaseOrder;
};
